import BaseAPI from './base-api';

export type ResetResponse = {
  isSuccess: boolean;
  error?: any;
};

export type RequestResponse = {
  isSuccess: boolean;
  error?: any;
};

export interface IPasswordResetService {
  reset: (
    password: string,
    passwordConfirmation: string,
    token: string | string[]
  ) => Promise<ResetResponse>;

  request: (email: string) => Promise<RequestResponse>;
}

export class PasswordRecoveryService extends BaseAPI implements IPasswordResetService {
  async reset(
    password: string,
    passwordConfirmation: string,
    token: string | string[]
  ): Promise<ResetResponse> {
    try {
      await this.http.patch('/accounts/password_reset', {
        password,
        password_confirmation: passwordConfirmation,
        token,
      });

      return { isSuccess: true };
    } catch (error: any) {
      return { isSuccess: false, error: error.response?.data };
    }
  }

  async request(email: string): Promise<RequestResponse> {
    try {
      await this.http.post('/accounts/password_recovery', { email });
      return { isSuccess: true };
    } catch (error: any) {
      return { isSuccess: false, error: error.response?.data };
    }
  }
}
